import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "./InputWrapper";
import ButtonWrapper from "./ButtonWrapper";
import SelectWrapper from "./SelectWrapper";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames } from "../helpingFunctions";
import { language } from "../utils/language";

const CardWrapper = styled.div`
  height: auto;
  width: 30%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const TransactionInfoCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [lang, setLang] = useState("en");
  const verifyManualTransactoinState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { data } = verifyManualTransactoinState;

  const bankMenu = [
    { value: "Siam Comercial Bank", id: "1" },
    { value: "Bangkok Bank", id: "2" },
    { value: "Kasikorn Bank", id: "3" },
  ];

  const transactionSchema = Yup.object().shape({
    bank: Yup.string()
      // .email("Please enter your valid email")
      .required(language[props.lang]?.trnxInfoCard.ERROR_PSB),
    accountNo: Yup.string()
      // .min(15, "Account number should be 15 digit.")
      // .max(15, "Account number should be 15 digit.")
      .matches(/^[0-9\s]+$/, "Only Numeric are allowed for this field")
      .required(language[props.lang]?.trnxInfoCard.ERROR_EAN),
    amount: Yup.string()
      .min(2, language[props.lang].trnxInfoCard.ERROR_AFP)
      .matches(/^\d*[\.{1}\d*]\d*$/, "Only Numeric are allowed for this field")
      .required(language[props.lang]?.trnxInfoCard.ERROR_AFP),
  });

  return (
    <CardWrapper className="">
      <div className="card-header w-100">
        <h3 className="text-center">{language[props.lang].trnxInfoCard.PTI}</h3>
      </div>
      <Formik
        initialValues={{
          bank: "",
          accountNo: "",
          amount: "",
        }}
        validationSchema={transactionSchema}
        onSubmit={(values) => {
          let getBankName = bankNames.filter(
            (item) => item.bankNameThai == values.bank
          );
          let qrManualTransactionParams = {
            qrCodeTransactionId: data.trxRef,
            bankName: getBankName[0].bankNameEng,
            accountNumber: values.accountNo,
            amount: parseFloat(values.amount),
            userId: data.merchantId,
          };
          if (values && data.userId) {
            dispatch({
              type: "WARNING_MODAL_SHOW",
              payLoad: true,
              data: qrManualTransactionParams,
            });
          }
        }}
        enableReinitialize={true}
      >
        {({
          onSubmit,
          values,
          errors,
          handleChange,
          handleSubmit,
          resetForm,
        }) => (
          <form noValidate onSubmit={handleSubmit} className="w-100 p-3">
            <p className="label mb-0">
              {language[props.lang].trnxInfoCard.BANK}*
            </p>
            <SelectWrapper
              name="bank"
              size="large"
              value={values.bank == "" ? null : <span>{values.bank}</span>}
              placeholder={`${language[props.lang].trnxInfoCard.SELECT_BANK}`}
              bankMenu={bankNames}
              onChange={handleChange("bank")}
            />
            {errors.bank ? (
              <p className="mb-4" style={{ color: "red" }}>
                {errors.bank}
              </p>
            ) : (
              <p className="mb-4"></p>
            )}

            <p className="label mb-0">
              {language[props.lang].trnxInfoCard.ACCOUNT_NO}*
            </p>
            <InputWrapper
              style={{ borderRadius: 10, marginTop: 0 }}
              name="accountNo"
              type="text"
              size="large"
              value={values.accountNo}
              onChange={handleChange("accountNo")}
              placeholder={language[props.lang].trnxInfoCard.ERROR_EAN}
            />
            {errors.accountNo ? (
              <p className="mb-4" style={{ color: "red" }}>
                {errors.accountNo}
              </p>
            ) : (
              <p className="mb-4"></p>
            )}

            <p className="label mb-0">
              {language[props.lang].trnxInfoCard.AMOUNT}(฿)*
            </p>
            <InputWrapper
              style={{ borderRadius: 10, marginTop: 0 }}
              name="amount"
              type="text"
              size="large"
              value={values.amount}
              onChange={handleChange("amount")}
              placeholder={language[props.lang].trnxInfoCard.ENTER_AMOUNT}
            />
            {errors.amount ? (
              <p className="mb-4" style={{ color: "red" }}>
                {errors.amount}
              </p>
            ) : (
              <p className="mb-4"></p>
            )}

            <div className="w-100">
              <ButtonWrapper
                border={true}
                size="middle"
                height="40px"
                htmlType="submit"
                className="w-100 mt-4"
                text={language[props.lang].trnxInfoCard.PROCEED_PAYMENT}
              />
            </div>
          </form>
        )}
      </Formik>
    </CardWrapper>
  );
};

export default TransactionInfoCard;
